<script setup lang="ts">
import { onUnmounted, ref } from 'vue'

interface HeroImage {
	title: string
	imgSrc: string
}

interface Props {
	images: HeroImage[]
}

const props = defineProps<Props>()

const currentImageIndex = ref(0)
const intervalId = ref<NodeJS.Timeout | null>(null)

const stopAutoRotate = () => {
	if (intervalId.value) {
		clearInterval(intervalId.value)
		intervalId.value = null
	}
}

onUnmounted(() => {
	stopAutoRotate()
})

const showNextImage = () => {
	if (props.images.length > 0) {
		currentImageIndex.value = (currentImageIndex.value + 1) % props.images.length
	}
}

const startAutoRotate = () => {
	intervalId.value = setInterval(showNextImage, 7500)
}

onMounted(() => {
	startAutoRotate()
})
</script>

<template>
	<div class="relative h-[275px] w-full">
		<!-- Background images with opacity transition -->
		<div
			v-for="(image, index) in images"
			:key="`bg-${index}`"
			class="absolute inset-0 bg-no-repeat transition-opacity duration-500"
			:class="{
				'opacity-0': index !== currentImageIndex,
				'opacity-100': index === currentImageIndex,
			}"
			:style="{
				backgroundImage: `url(${image.imgSrc})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center right',
			}"
		></div>
	</div>
</template>
